module.exports = __webpack_public_path__ + "static/media/presov.82a0b566.jpg";